import { render, staticRenderFns } from "./ContactAndSupport.vue?vue&type=template&id=74ddcc20&"
import script from "./ContactAndSupport.vue?vue&type=script&lang=ts&"
export * from "./ContactAndSupport.vue?vue&type=script&lang=ts&"
import style0 from "./ContactAndSupport.vue?vue&type=style&index=0&id=74ddcc20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports